// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/source/resources/file_upload_intent/file_upload_intent.proto (package gx.source.resources.file_upload_intent, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file services/source/resources/file_upload_intent/file_upload_intent.proto.
 */
export const file_services_source_resources_file_upload_intent_file_upload_intent = /*@__PURE__*/
  fileDesc("CkVzZXJ2aWNlcy9zb3VyY2UvcmVzb3VyY2VzL2ZpbGVfdXBsb2FkX2ludGVudC9maWxlX3VwbG9hZF9pbnRlbnQucHJvdG8SJmd4LnNvdXJjZS5yZXNvdXJjZXMuZmlsZV91cGxvYWRfaW50ZW50IpABChBGaWxlVXBsb2FkSW50ZW50EhMKC3NvdXJjZV9wYXRoGAEgASgJEkcKC3VwbG9hZF9tb2RlGAIgASgOMjIuZ3guc291cmNlLnJlc291cmNlcy5maWxlX3VwbG9hZF9pbnRlbnQuVXBsb2FkTW9kZRILCgNrZXkYAyABKAkSEQoJZmlsZV9zaXplGAQgASgDKl0KClVwbG9hZE1vZGUSGwoXVVBMT0FEX01PREVfVU5TUEVDSUZJRUQQABIWChJVUExPQURfTU9ERV9TT1VSQ0UQARIaChZVUExPQURfTU9ERV9HQUxBWFlfQ0ROEAJC0QIKKmNvbS5neC5zb3VyY2UucmVzb3VyY2VzLmZpbGVfdXBsb2FkX2ludGVudEIVRmlsZVVwbG9hZEludGVudFByb3RvUAFaWGdpdGh1Yi5jb20vZ2FsYXh5LWlvL2d4L3NoYXJlZC9nby9jb250cmFjdHMvc2VydmljZXMvc291cmNlL3Jlc291cmNlcy9maWxlX3VwbG9hZF9pbnRlbnSiAgRHU1JGqgIkR3guU291cmNlLlJlc291cmNlcy5GaWxlVXBsb2FkSW50ZW50ygIkR3hcU291cmNlXFJlc291cmNlc1xGaWxlVXBsb2FkSW50ZW504gIwR3hcU291cmNlXFJlc291cmNlc1xGaWxlVXBsb2FkSW50ZW50XEdQQk1ldGFkYXRh6gInR3g6OlNvdXJjZTo6UmVzb3VyY2VzOjpGaWxlVXBsb2FkSW50ZW50YgZwcm90bzM");

/**
 * Describes the message gx.source.resources.file_upload_intent.FileUploadIntent.
 * Use `create(FileUploadIntentSchema)` to create a new message.
 */
export const FileUploadIntentSchema = /*@__PURE__*/
  messageDesc(file_services_source_resources_file_upload_intent_file_upload_intent, 0);

/**
 * Describes the enum gx.source.resources.file_upload_intent.UploadMode.
 */
export const UploadModeSchema = /*@__PURE__*/
  enumDesc(file_services_source_resources_file_upload_intent_file_upload_intent, 0);

/**
 * @generated from enum gx.source.resources.file_upload_intent.UploadMode
 */
export const UploadMode = /*@__PURE__*/
  tsEnum(UploadModeSchema);

